import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/ai/homework-helper/page.tsx");
